import * as angular from "angular";
import * as _ from "lodash";

angular
  .module('bringoz.admin.commons')
  .filter('servicePackageWeight', servicePackageWeight);

function servicePackageWeight(splitService, $filter) {
  return function servicePackageWeightFilter(packages, enableUnitDisplay) {

    const countAsTotal = splitService.getPackageWeightIsTotal();

    const itemsWeightSum = _.reduce(packages, (sum, i) => {
      const itemWeight = _.get(i, 'weight', 0);
      return countAsTotal ? sum + itemWeight : sum + itemWeight * _.get(i, 'count', 0);
    }, null);

    return itemsWeightSum ? $filter('bringozWeight')(itemsWeightSum, enableUnitDisplay) : '--';
  };
}
